import { Highlight } from "@mantine/core";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/highlight/Highlight.tsx
/**
* Highlights given substring(s) by passing the main string as children and string part(s) that should be highlighted to highlight prop. If the main string does not include highlight part, it will be ignored.
*/
const Highlight$1 = ({ highlight, children, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Highlight, {
		highlightStyles: {
			fontWeight: 600,
			WebkitBackgroundClip: "text",
			WebkitTextFillColor: "var(--mantine-color-primary-7)"
		},
		highlight,
		"data-testid": testId,
		children
	});
};

//#endregion
export { Highlight$1 as Highlight };